import { sendRaygunError } from "../useRaygun";
import type { CurrentMember } from "./types";
import { fetchActiveFlagKeys, fetchEvaluateFlags } from "./api";
import { FlagRecord } from "./flags";

const initializeFeatures = async (currentMember: CurrentMember): Promise<FlagRecord | undefined> => {
  try {
    const activeFlagKeys = await fetchActiveFlagKeys();
    if (activeFlagKeys.length > 0) {
      const flagValues = await fetchEvaluateFlags(activeFlagKeys, currentMember);
      return flagValues;
    }
  } catch (e) {
    sendRaygunError(new Error(`Flagr Api Error: ${e || "Unknown error"}`));
  }
};

export default initializeFeatures;
